import React, { FC } from 'react';

import { Box, Icon } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants, IActionButtonProps } from 'components/action-button';
import { primitive } from 'styles/constants/primitives';

interface IRefreshButtonProps extends IActionButtonProps {
  onPress: (ev: any) => void;
}

export const RefreshButton: FC<React.PropsWithChildren<IRefreshButtonProps>> = ({
  children,
  onPress,
}) => {
  return (
    <Box alignItems="center" marginY="$4">
      <ActionButton
        variant={ActionButtonVariants.OUTLINE}
        onPress={onPress}
        startIcon={<Icon variant="refresh" color={primitive.bk.$bbqBrown} aria-hidden />}
      >
        {children}
      </ActionButton>
    </Box>
  );
};
